
namespace RedBullMOBILE360.AutomaticReports {

    @Serenity.Decorators.registerClass()
    export class ReportLogGrid extends Serenity.EntityGrid<ReportLogRow, any> {
        protected getColumnsKey() { return ReportLogColumns.columnsKey; }
        protected getDialogType() { return ReportLogDialog; }
        protected getIdProperty() { return ReportLogRow.idProperty; }
        protected getInsertPermission() { return ReportLogRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportLogRow.localTextPrefix; }
        protected getService() { return ReportLogService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}